<template>
  <div class="main-container myorder deposit mt30">
    <!--    <code>    {{ orders }}</code>-->
    <div class="container-fluid device-max-area">
      <div class="row">
        <div class="col-md-12">
          <div class="myorders mt30" v-if="promotion">
            <div class="status-msg"><img src="@/assets/images/info-blue.png" width="18px">&nbsp; {{promotion}}
              Delivered.
            </div>
          </div>
          <div>

            <div class="income_summary animated slideInUp">
              <img src="@/assets/images/baloon.png" class="leftbg" alt="alt">
              <br />
              <br />
              <br />
              <p class="deposit-title"> <b>Your <br>Remaining Deposit <br> Amount</b>

              </p>

              <img src="@/assets/images/up.png" class="up" alt="alt">
              <p><span> <span class="animated bounceIn">{{customer_deposit_amount}} &#8364;</span></span>
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="morelink">
            <button data-toggle="modal" data-target="#DepositRequestModal" class="btn btn-sm btn-orange">Request For
              Deposir Money</button><br><br>
            <router-link :to="{ path: '/deposit-history'}">Deposit History</router-link>
            |
            <router-link :to="{ path: '/deposit-order-list'}">Deposit Order History</router-link>

            <div id="DepositRequestModal" class="modal authModal fade" role="dialog">
              <div class="vertical-alignment-helper">
                <div class="modal-dialog vertical-align-center">
                  <!-- Modal content-->
                  <div class="modal-content">
                    <div class="modal-body">
                      <button type="button" class="close" data-dismiss="modal"><img
                          src="@/assets/images/close.png"></button>
                      <div>
                        <span class="logo text-center">
                          <img src="@/assets/images/ghasforing-logo.png" class="img-responsive"
                            style="max-width: 150px;margin: auto" alt="Logo" />
                        </span>
                        <h3 class="mb20">Request For Deposit Money</h3>
                        <div class="form-group">
                          <select class="form-control" v-model="payment_method">
                            <option value="Hand-Cash">Deposit By Hand Cash</option>
                            <option value="B-Kash">Deposit By B-Kash Payment</option>
                            <option value="Nagad">Deposit By Nagad</option>
                          </select>
                        </div>
                        <div class="form-group">
                          <input type="text" class="form-control" v-model="amount" placeholder="Input Deposit Amount">
                        </div>
                        <div v-if="payment_method !='Hand-Cash'">
                          <div class="form-group">
                            <input type="text" class="form-control" v-model="number"
                              placeholder="Input your Cash Out Phone Number">
                          </div>
                          <div class="form-group">
                            <input type="text" class="form-control" v-model="transaction_id"
                              placeholder="Input Your Transaction ID">
                          </div>
                        </div>
                        <div class="form-group">
                          <textarea class="form-control" v-model="requestMessage" placeholder="Your Message"></textarea>
                        </div>
                        <button @click="sendDepositRequest" type="submit" class="btn btn-login">Send Now</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  const $ = require('jquery');
  window.$ = $;
  $(function () {
    $(window)
      .scroll(function () {
        $('nav')
          .toggleClass('scrolled', $(this)
            .scrollTop() > 20);
      });

  });

  import axios from 'axios';

  export default {
    data() {
      return {
        token: '',
        transaction_id:  null,
        number:  null,
        payment_method:  'Hand-Cash',
        requestMessage: null,
        amount: null,
        promotion: null,
        customer_deposit_amount:0

      };
    },
    created: function () {
      this.loadApiData();
    },
    methods: {
      sendDepositRequest: function () {
        let vm = this;
        if(vm.amount >0){
          axios.post(this.globalUrl + 'deposit-request',
            {
              payment_method: vm.payment_method,
              customer_id: localStorage.getItem('logged_in_user_id'),
              number: vm.number,
              transaction_id: vm.transaction_id,
              amount: vm.amount,
              requestMessage: vm.requestMessage
            }, {crossdomain: true})
            .then((response) => {
              console.log(response);
              vm.number = null;
              vm.transaction_id = null;
              vm.amount = null;
              vm.requestMessage = null;
              this.$toasted.show('Your Request Sent, We will contact with you soon. Thanks', {
                type: 'success',
                icon: 'fa-exclamation-triangle',
                duration: 10000
              });
              setTimeout(() => { this.$router.go(this.$router.currentRoute); }, 3000);

            })
            .catch((response) => {
              this.$toasted.show('Something Wrong, Try again', {
                type: 'error',
                icon: 'fa-exclamation-triangle',
                duration: 10000
              });
              console.log(response);
            });
        }else{
          this.$toasted.show('Please fill the form', {
            type: 'error',
            icon: 'fa-exclamation-triangle',
            duration: 10000
          });
        }
      },
      loadApiData: function () {
        let vm = this;
          let logged_in_user_id = localStorage.getItem('logged_in_user_id');

          axios.get(this.globalUrl + "deposit-history/" + logged_in_user_id)
            .then(function (response) {
              console.log(response);
              if(response.data.deposit_total >0){
                vm.customer_deposit_amount = response.data.deposit_total;
                vm.promotion = response.data.promotion;
              }
            })
            .catch((response) => {
            });
        }
    }
  };
</script>
